@if (links.length > 0 && translationEntryPoint) {
  <ul nz-menu nzMode="horizontal">
    @for (link of links; track link) {
      <li nz-menu-item nzMatchRouter>
        <a [routerLink]="[link]">
          {{ translationEntryPoint + replaceDashes(link) | translate }}
        </a>
      </li>
    }
  </ul>
}
